import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Project } from "@/v2/types";
import { Pagination } from "@/v2/types/Datatable";

export default async function FindAllProjects({
    skip,
    limit,
    search,
    order,
    orderBy,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    order?: string;
    orderBy?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Project[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: `/projects`,
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...(order && { order }),
            ...(orderBy && { order_by: orderBy }),
            ...filter,
        },
    });
    return res.data;
}
